var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ratings > 0)?_c('div',{staticClass:"star-ratings"},_vm._l((Math.round(_vm.ratings)),function(n){return _c('i',{key:'start' + n,staticClass:"el-icon-star-on star-ratings-item"})}),0):_c('div',{staticClass:"star-ratings"},_vm._l((5),function(n){return _c('i',{key:'start' + n,staticClass:"el-icon-star-off star-ratings-item-off"})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }